import React from 'react';

import { CreditSlips } from '@C/CreditCustomers/RouteComponents';
import { useGlobalStore } from '@stores/globalStore';

const CreditSaleSummary = (props) => {
  const { syncCODCollectionData, isViewMode } = props;

  const updateTotalSummary = () => {
    syncCODCollectionData(props.match.params.duty, props.match.params.staff);
  };

  return (
    <CreditSlips
      {...props}
      cod={true}
      onDataChange={updateTotalSummary}
      readOnly={isViewMode}
    />
  );
};

export { CreditSaleSummary };
